<div class="hidden lg:block">
	<footer
		style="background-image: url(/images/bgfootercolor.png); background-size:cover; background-position:center"
	>
		<div class="py-10 container mx-auto px-5 lg:px-16">
			<div class="grid grid-cols-12 gap-10">
				<div class="col-span-4">
					<div class="flex flex-col items-start">
						<img src="/images/sohamlogowhitemobile.png" class="h-36 object-contain" alt="logo" />
						<h1 class="gilda text-white text-4xl">Indulge in Happiness at SOHAM Wellness Center</h1>
					</div>
				</div>
				<div class="col-span-8">
					<div class="flex items-start gap-20 ps-10">
						<div>
							<ul class="flex flex-col items-start gap-5">
								<li>
									<a data-sveltekit-reload href="/" class="block text-xl font-light text-white uppercase">Home</a>
								</li>
								<li>
									<a data-sveltekit-reload href="/wellness" class="block text-xl font-light text-white uppercase"
										>Wellness</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="/membership" class="block text-xl font-light text-white uppercase">Membership</a>
								</li>
								<li>
									<a data-sveltekit-reload href="/facilities" class="block text-xl font-light text-white uppercase"
										>Facilities</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="/about-us" class="block text-xl font-light text-white uppercase"
										>About Us</a
									>
								</li>
							</ul>
						</div>
						<div>
							<ul class="flex flex-col items-start gap-5 w-[107%]">
								<li>
									<a data-sveltekit-reload href="/wellness" class="block text-xl font-light text-white uppercase"
										>Wellness</a
									>
								</li>

								<li>
									<a data-sveltekit-reload href="/wellness/gym" class="block text-md font-light text-white">GYM</a>
								</li>
								<li>
									<a data-sveltekit-reload href="/wellness/spa-treatments" class="block text-md font-light text-white"
										>SPA Treatment</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="/wellness/yoga-classes" class="block text-md font-light text-white"
										>Yoga Clasess</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="/wellness/fitness-classes" class="block text-md font-light text-white"
										>Fitness Classes</a
									>
								</li>
							</ul>
						</div>
						<div>
							<ul class="flex flex-col items-start gap-5">
								<li>
									<p class="block text-xl font-light text-white uppercase">OUR ADDRESS</p>
								</li>

								<li>
									<a
										data-sveltekit-reload href="https://maps.app.goo.gl/7SifFxUrpi3Etitw5"
										class="block text-md font-light text-white"
										>Jalan Lebak Sari No. 7, Gg. Stap, Kerobokan Kelod, Kec. Kuta Utara, Kabupaten Badung, Bali 80361</a
									>
								</li>
								<!-- <li>
									<a data-sveltekit-reload href="tel:+62 821 4618 6424" class="block text-md font-light text-white"
										>+62 821 4618 6424</a
									>
								</li> -->
								<li>
									<a data-sveltekit-reload href="https://wa.me//6287774741616" class="block text-md font-light text-white"
										>Whatsapp : +62 877 7474 1616</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="tel:+623614741616" class="block text-md font-light text-white"
										>Telp : +62 361 4741 616</a
									>
								</li>
								<li>
									<a	
										data-sveltekit-reload href="mailto:info@sohamwellnesscenter.com"
										class="block text-md font-light text-white">info@sohamwellnesscenter.com</a
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="flex items-center gap-2 mt-10">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="751"
					height="3"
					viewBox="0 0 751 3"
					fill="none"
				>
					<path d="M0 1.89941H750.101" stroke="white" stroke-width="2" />
				</svg>

				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						x="1.5148"
						y="9.89941"
						width="12"
						height="12"
						transform="rotate(-45 1.5148 9.89941)"
						stroke="white"
						stroke-width="2"
					/>
				</svg>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="751"
					height="3"
					viewBox="0 0 751 3"
					fill="none"
				>
					<path d="M0 1.89941H750.101" stroke="white" stroke-width="2" />
				</svg>
			</div>
			<p class="text-center text-white mt-5">
				Copyright© 2024 SOHAM Wellness Center Bali. All rights reserved. Powered by Mindimedia.
			</p>
		</div>
	</footer>
</div>

<div class="block lg:hidden">
	<footer
		style="background-image: url(/images/bgfootercolor.png); background-size:cover; background-position:center"
	>
		<div class="pt-10 pb-40 px-5 lg:px-16">
			<div class="flex flex-col items-center justify-center gap-10">
				<div class="flex flex-col items-start">
					<img
						src="/images/sohamlogowhitemobile.png"
						class="h-36 object-contain mx-auto"
						alt="logo"
					/>
					<h1 class="gilda text-white text-3xl text-center">
						Indulge in Happiness at SOHAM Wellness Center
					</h1>
				</div>
				<div>
					<div class="flex flex-col items-center justify-center gap-20">
						<div>
							<ul class="flex flex-col items-center gap-5">
								<li>
									<a data-sveltekit-reload href="/" class="block text-xl text-center font-light text-white uppercase"
										>Home</a
									>
								</li>
								<li>
									<a
										data-sveltekit-reload href="/wellness"
										class="block text-xl text-center font-light text-white uppercase">Wellness</a
									>
								</li>
								<li>
									<a
										data-sveltekit-reload href="/membership"
										class="block text-xl text-center font-light text-white uppercase">Membership</a
									>
								</li>
								<li>
									<a
										data-sveltekit-reload href="/facilities"
										class="block text-xl text-center font-light text-white uppercase">Facilities</a
									>
								</li>
								<li>
									<a
										data-sveltekit-reload href="/about-us"
										class="block text-xl text-center font-light text-white uppercase">About Us</a
									>
								</li>
							</ul>
						</div>

						<div>
							<ul class="flex flex-col items-center gap-2">
								<li>
									<a data-sveltekit-reload href="/" class="block text-md font-light text-white text-center"
										>Gg. Stap No.7, Kerobokan Kelod, Kec. Kuta Utara, Kabupaten Badung, Bali 80361</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="https://wa.me//6287774741616" class="block text-md font-light text-white"
										>Whatsapp : +62 877 7474 1616</a
									>
								</li>
								<li>
									<a data-sveltekit-reload href="/" class="block text-md font-light text-white">Telp : +62 361 4741 616</a>
								</li>
								<li>
									<a data-sveltekit-reload href="/" class="block text-md font-light text-white">info@sohamwellnesscenter.com</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="flex items-center gap-2 mt-10">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="751"
					height="3"
					viewBox="0 0 751 3"
					fill="none"
				>
					<path d="M0 1.89941H750.101" stroke="white" stroke-width="2" />
				</svg>

				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect
						x="1.5148"
						y="9.89941"
						width="12"
						height="12"
						transform="rotate(-45 1.5148 9.89941)"
						stroke="white"
						stroke-width="2"
					/>
				</svg>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="751"
					height="3"
					viewBox="0 0 751 3"
					fill="none"
				>
					<path d="M0 1.89941H750.101" stroke="white" stroke-width="2" />
				</svg>
			</div>
			<p class="text-center text-white mt-5">
				Copyright© 2024 SOHAM Wellness Center Bali. All rights reserved. Powered by Mindimedia.
			</p>
		</div>
	</footer>
</div>
